
const getLimitRouterApi = async ({
    senderCountry,
    senderCurrency,
    receiverCountry,
    receiverCurrency,
    sessionId,
    operationName = "limits",
    origin = window.location.host,
    platform = "nextgen",
    source = "ExpPlatform",
    displaySystem = "Web",
    isRREnabled = "true"
}) => {
    const cachedData = getLimitCacheData(receiverCountry)
    if(cachedData?.data?.limits) return cachedData
    
    const uniqueId = `web-` + generateUniqueID();
    const uniqueIdCorrelation = `web-` + generateUniqueID();
    const myHeaders = new Headers();
    senderCountry = senderCountry.toUpperCase()
    receiverCountry = receiverCountry.toUpperCase()
    myHeaders.append("accept", "*/*");
    myHeaders.append("displaysystem", displaySystem);
    myHeaders.append("isrrenabled", isRREnabled);
    myHeaders.append("origin", origin);
    myHeaders.append("platform", platform);
    myHeaders.append("source", source);
    myHeaders.append("wucountrycode", senderCountry);
    myHeaders.append("wulanguagecode", window.pageData.language);
    myHeaders.append("x-wu-accesscode", 'RtYV3XDz9EA');
    myHeaders.append("x-wu-apikey", 1978);
    myHeaders.append("x-wu-correlationid", uniqueId);
    myHeaders.append("x-wu-externalrefid", uniqueIdCorrelation);
    myHeaders.append("x-wu-operationname", operationName);
    myHeaders.append("x-wu-retailsessionid", "");
    myHeaders.append("x-wu-sessionid", sessionId);
    myHeaders.append("content-type", 'application/json');

    const graphql = JSON.stringify({
        query: `query  limits( $req:LimitsInput, ) { limits(input: $req) {
            __typename
            ...on LimitsResponse{
                limits{
                    type
                    serviceCode
                    minLimit
                    maxLimit
                    limit
                }
                transactionLimit{
                    type
                    payIn
                    serviceCode
                    minLimit
                    maxLimit
                    limit
                }
                aggregatedTxnAmount
            }
            ... on ErrorResponse{
                errorCode
                message
            }
        } }`,
        variables: {
            req: {
                senderCountry,
                senderCurrency,
                receiverCountry,
                receiverCurrency,
                version: "2",
                security: {
                    session: {
                        id: sessionId
                    }
                }
            }
        }
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow"
    };

    let response = await fetch("/router/", requestOptions)
    response = await response.json()
    sessionStorage.setItem(`${LIMITS_CACHE_KEY}-${receiverCountry}`, JSON.stringify(response));
    return response
}